export enum Role {
    admin,
    normal,
    unauthorized,
    checkPoint
}


// WEBPACK FOOTER //
// ./src/models/roles.ts